import React from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import "./FeaturesItem.scss";
import Link from "../../Elements/Link/Link.js";

const RightComponent = ({ myprops }) => {
  const { getLanguageCulture, getTextByKey } = useContent();
  const location = useLocation();
  const currentPath = location.pathname.split("/")[3];
  return (
    <div className="right-section">
      <h2>{getTextByKey("more-features")}</h2>
      <div className="body-right-section">
        {Object.keys(myprops).map((itemName) => {
          return (
            <div className="features-links" key={itemName}>
              <a
                className={
                  currentPath === itemName ? "link-ref-pointer" : "link-ref"
                }
                href={`/${getLanguageCulture().substring(
                  0,
                  2
                )}/features/${itemName}`}
              >
                {myprops[itemName].service_category_title}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RightComponent;
